export enum UserOnlineStatus {
    Online = 'online',
    Offline = 'offline'
}